module.exports = __webpack_public_path__ + "media/images/front/icon_review_yj_r-618dac6476a8bd9d62c2a9e8602f4e86.png";